import { Pipe, PipeTransform } from '@angular/core';
import { AccountAttributesEnum } from '../enums';
import { UserService } from '../../core/services/user.service';
import { AuthenticationService } from '../../core/services/authentication.service';

@Pipe({
    name: 'isExportEnabled'
})
export class IsExportEnabledPipe implements PipeTransform {
    constructor(
        private userService: UserService,
        private auth: AuthenticationService,
    ) {}

    transform(exportType: AccountAttributesEnum, areOnlyMvSelected: boolean): boolean {
        const isAllowExportOfPendingVerificationContacts: boolean = this.auth.isAllowExportOfPendingVerificationContacts()
        const isTierExportEnabled: boolean = isAllowExportOfPendingVerificationContacts || !areOnlyMvSelected;
        if (!isTierExportEnabled) {
            return false;
        }
        return this.userService.hasAccess(exportType);
    }
}
